module.exports = __webpack_public_path__ + "d4af20db1d93ea209d43f12751a82e99.svg";